export const SOFTLINE_PERMISSION_CUSTOMER_QUERY = 'KUNDENABFRAGE';
